'use client';

import { LazyLottie } from '../LazyLottie';
import { IAnimationProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation for the showing flashing error icon
 */
export function PermissionsAccessErrorAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('../raw-json/functional-assessment/permission-error.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="PermissionsAccessErrorAnimation"
    />
  );
}
